import { backendApi } from "../dynamicBAseQuery"

export const dashboardApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getClientDropdown: builder.query({
            query: () => ({
                method: "GET",
                url: `client/getClientDropDown`
            })
        }),
        getDashboardCount: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `DashboardCount`,
                body: { ...args }
            })
        }),
        getTableDatas: builder.mutation({
            query: ({ userRole, ...args }) => ({
                method: "POST",
                url: userRole === "recruiter" ? `v2/dashboardRecruiter` : `v2/dashboard`,
                body: args,
            }),
        }),

        getDashboardActivityCount: builder.query({
            query: () => ({
                method: "GET",
                url: `v2/dashboardActivityCount`
            })
        }),

        getRecruiterTableDatas: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `recruiter/dashboard`,
                body: { ...args }
            })
        }),
    })
})

export const {
    useGetClientDropdownQuery,
    useGetDashboardCountMutation,
    useGetTableDatasMutation,
    useGetDashboardActivityCountQuery,
    useGetRecruiterTableDatasMutation
} = dashboardApi